import { useCallback, useMemo, useState, type ReactNode } from "react";
import { ToastContext, type ToastTone } from "./toast-context";

type Toast = {
  id: number;
  message: string;
  tone: ToastTone;
};

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const announce = useCallback(
    (message: string, tone: Toast["tone"] = "info") => {
      const id = Date.now();
      setToasts((current) => [
        ...current.filter((toast) => toast.message !== message),
        { id, message, tone },
      ]);
      window.setTimeout(
        () =>
          setToasts((current) => current.filter((toast) => toast.id !== id)),
        4200,
      );
    },
    [],
  );
  const value = useMemo(() => announce, [announce]);
  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="toast-region" aria-live="polite" aria-atomic="true">
        {toasts.map((toast) => (
          <div className={`toast toast--${toast.tone}`} key={toast.id}>
            {toast.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
